<script>

import FakerInput from './FakerInput'

export default {

  components: {
    FakerInput
  },

  props: {
    value: {
      type: Object,
      required: true
    },

    label: {},
    readOnlyData: {},

    left: {
      type: Object,
      default: {}
    },

    right: {
      type: Object,
      default: {}
    },

    allowFakeInput: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      internalValue: this.value,

      newName: null,
      newValue: null,

      showNewRow: false
    }
  },

  computed: {
    hasData() {
      return Object.keys(this.internalValue).length > 0
    },

    editing() {
      return !!(this.newName && this.internalValue[this.newName])
    }
  },

  methods: {
    addParameter() {
      this.$set(this.internalValue, this.newName, this.newValue)
      this.showNewRow = false
    },

    removeKey(key) {
      this.$delete(this.internalValue, key)
    },

    edit(key) {
      this.showNewRow = true
      this.newName = key
      this.newValue = this.internalValue[key]
    },

    isPathInput(value) {
      return value && value.slice(0, 5) == "path."
    }

  },

  watch: {
    internalValue() {
      this.$emit('input', this.internalValue)
    },

    showNewRow() {
      if (!this.showNewRow) {
        this.newName = null
        this.newValue = null
      }

    }
  }

}
</script>

<template>
  <div>
  <b-field horizontal :label="label">
    <div>
      <div v-if="readOnlyData">
        <div class="columns is-mobile has-small-spacing" v-for="key in readOnlyData">
          <div class="column is-5 has-text-right">
            <pre>{{ key }}</pre>
          </div>
          <div class="column is-5 has-text-left">
            &nbsp;
          </div>
        </div>
      </div>

      <div v-if="hasData">
        <div class="columns is-mobile has-small-spacing" v-for="(value, key) in internalValue">
          <div class="column is-5 has-text-right">
            <pre>{{ key }}</pre>
          </div>
          <div class="column is-5 has-text-left">
            <pre>{{ value }}</pre>
          </div>
          <div class="column is-2 has-text-right">
            <div v-if="!isPathInput(value)">
              <b-button @click="edit(key)" type="is-text" icon-right="pencil" size="is-small" />
              <b-button @click="removeKey(key)" type="is-danger" icon-right="delete" size="is-small" />
            </div>
          </div>
        </div>
      </div>
      <p v-else>No data yet</p>

    </div>
  </b-field>

  <b-field horizontal v-if="showNewRow" class="has-space-top">

    <div class="columns">
      <div class="column">
        <b-field :label="left.label" :message="left.message">
          <b-input :placeholder="left.placeholder" v-model="newName" expanded></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field :label="right.label" :message="right.message">
          <faker-input v-if="allowFakeInput" :placeholder="right.placeholder" v-model="newValue"></faker-input>
          <b-input v-else :placeholder="right.placeholder" v-model="newValue" expanded></b-input>
        </b-field>
      </div>
    </div>

  </b-field>

  <b-field horizontal>
    <div class="buttons">
      <b-button v-if="showNewRow" @click="addParameter" type="is-text" icon-left="check" :disabled="!newName || !newValue">
        <span v-if="editing">Update</span>
        <span v-else>Add</span>
      </b-button>
      <b-button v-else @click="showNewRow = true" icon-left="plus">Add</b-button>
      <b-button v-if="showNewRow" type="is-text" @click="showNewRow = false">Cancel</b-button>
    </div>
  </b-field>
  </div>
</template>

<style lang="scss" scoped>
pre {
  padding: 0.25rem 0.5rem;
}
.column {
  padding-top: 0;
  padding-bottom: 0;
}
.buttons {
  padding-top: 15px;
}
.has-small-spacing, .columns.has-small-spacing {
  margin-top: 5px;
  margin-bottom: 5px;
}
.has-space-top {
  margin-top: 20px;
}
</style>